import { useState } from 'react';
import { ANON_IDENTITY, usePort, useRowboat } from '@/rowboat';
import { setCaptureContext } from '@/services/captureContext';
import { createEstate } from '@/services/estateService';
import { Alert, Button, Field, Muted, Page, TextInput } from './ui';

/** First launch with no estates: name the project, then land on Items. */
export function FirstRunSetup() {
  const graph = useRowboat();
  const { author, mintGroup } = usePort();
  const actor = author ?? ANON_IDENTITY;
  const [estateName, setEstateName] = useState('');
  const [working, setWorking] = useState(false);
  const [error, setError] = useState('');

  const create = async () => {
    const name = estateName.trim();
    if (!name || working) return;
    setWorking(true);
    setError('');
    try {
      const groupId = await mintGroup(crypto.randomUUID());
      const id = await createEstate(graph, { name, author: actor, groupId });
      await setCaptureContext(graph, actor, { estateId: id });
      setEstateName('');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not create estate');
    } finally {
      setWorking(false);
    }
  };

  return (
    <Page label="First run setup">
      <h1 className="text-2xl font-bold text-content-primary">Catalog your first estate</h1>
      <Muted>
        Name the estate — usually the house or property. Then add groups (rooms or areas, each with
        a numbering prefix) in the Project menu, ☰ at the top right.
      </Muted>
      <Field label="Estate name">
        <TextInput
          aria-label="Estate name"
          value={estateName}
          onChange={(e) => setEstateName(e.target.value)}
          placeholder="e.g. Maple Street house"
        />
      </Field>
      <Button onClick={() => void create()} disabled={!estateName.trim() || working}>
        Start capturing
      </Button>
      {error && <Alert>{error}</Alert>}
    </Page>
  );
}
